const normaliseId = (value) => {
  if (!value) return ''
  if (typeof value === 'object') return value._id?.toString?.() ?? ''
  return value.toString?.() ?? ''
}

const getLevelConfig = (bagLevels = [], levelName = '') => {
  const key = levelName?.trim?.().toLowerCase()

  return bagLevels.find((level) => {
    const name = typeof level === 'string' ? level : level?.name
    return name?.trim?.().toLowerCase() === key
  })
}

const getCustomBagAlarm = (medicine, location, bagLevels = []) => {
  if (location?.type === 'Medicine Store') return undefined

  const levelConfig = getLevelConfig(bagLevels, location?.level)
  if (!levelConfig?.customAlarms?.enabled) return undefined

  const medicineId = normaliseId(medicine?._id)
  const override = levelConfig.customAlarms.medicines?.find(
    (alarm) => normaliseId(alarm?.medicine) === medicineId,
  )

  return override?.minNumberInBags
}

const getMedicineAlarm = (medicine, location, bagLevels = []) => {
  if (location?.type === 'Medicine Store') return medicine?.minNumberInStores

  return getCustomBagAlarm(medicine, location, bagLevels) ?? medicine?.minNumberInBags
}

export default getMedicineAlarm
